// extracted by mini-css-extract-plugin
export default {"wishlist":"WhishList_wishlist__sCOia"};